import { Component } from '@angular/core';
import { HARDCOPY_PRODUCT_NAME } from '../../settings';

@Component({
    selector: 'hardcopy-header',
    templateUrl: 'header.html',
    host: {
        class: 'header'
    }
})

export class HardcopyHeaderComponent {

    public productName: string = HARDCOPY_PRODUCT_NAME;

    constructor(

    ) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/components/header/header.ts